import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_badge_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    applet_login_subject_link_guid: fromDatatype.GuidDataFieldInterface;
    ws_event_code: fromDatatype.VarcharDatatypeInterface;
    ws_event_type: fromDatatype.VarcharDatatypeInterface;
    ws_event_option: fromDatatype.JsonDatatypeInterface;
    message_content: fromDatatype.VarcharDatatypeInterface;
    notification_count: fromDatatype.IntegerDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}


export class bl_applet_badge_hdr_RowClass implements bl_applet_badge_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    applet_login_subject_link_guid: fromDatatype.GuidDataFieldInterface;
    ws_event_code: fromDatatype.VarcharDatatypeInterface;
    ws_event_type: fromDatatype.VarcharDatatypeInterface;
    ws_event_option: fromDatatype.JsonDatatypeInterface;
    message_content: fromDatatype.VarcharDatatypeInterface;
    notification_count: fromDatatype.IntegerDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
